import React from "react"
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledModalBody, StyledModalV2 } from "../../../components/Modals";
import { Flex } from "../../../components/ui/Flex";
import { ButtonBodyVariant } from "../../../components/ui/ButtonVariant";
import { closeActiveModal } from "../../../helper/modals";
import { Fonts, Palette } from "../../../components/utils";
import { IoMdCheckmark } from "react-icons/io";
import styled from "styled-components";

const ConfirmationModal = () => {
  const { t } = useTranslation();
  const { modal, data } = useSelector((state) => state.headerModal);

  const onClick = () => {
    data.onClick();
    closeActiveModal();
  }

  return (
    <StyledModal
      show={modal === 'ConfirmationModal'}
      onClose={closeActiveModal}
      closeOnBackdrop={false}
      width={'460px'}
      padding={"2.25rem 1.5rem 3rem 1.5rem"}
    >
      <StyledModalBody>
        <Flex direction="column" alignItems="center" gap="1.5rem">
          <IconBackground background={Palette.GREEN_500}>
            <IoMdCheckmark size={32} color={Palette.WHITE} style={{ position: "absolute", right: "12px", top: "11px" }} />
          </IconBackground>
          <Flex direction="column" alignItems="center" gap="1rem">

            <TitleText lg>{t('Confirmation')}</TitleText>
            <DescriptionText>
              {data.description}
            </DescriptionText>
          </Flex>
          <ModalButtonsContainer>
            <ButtonBodyVariant cssOverride={"width: 100%;"} onClick={onClick}>{t('Confirm')}</ButtonBodyVariant>
            <ButtonBodyVariant variant="secondary" onClick={closeActiveModal} cssOverride={"width: 100%;"}>{t('Cancel')}</ButtonBodyVariant>
          </ModalButtonsContainer>
        </Flex>
      </StyledModalBody>
    </StyledModal>
  )
}

export const TitleText = styled.p`
  color: ${Palette.BLACK};

  font-family: ${Fonts.RED_HAT_FONT};
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 800;
  line-height: 2rem;
  letter-spacing: 0rem;
  margin: 0;
`

export const DescriptionText = styled.p`
  color: ${Palette.BLACK};
  text-align: center;

  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0rem;
  margin: 0;
`

export const IconBackground = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 100%;
  position: relative;

  ${({ background }) =>
    background && `background-color: ${background};`}
`

export const ModalButtonsContainer = styled(Flex)`
  width: 100%;
  padding: 0;
  padding-top: 1rem;
  gap: 0.5rem;
  justify-content: end;
`;

export default ConfirmationModal